export const TITLE_MIN_LEN = 3;
export const TITLE_MAX_LEN = 80;
export const DESCRIPTION_MAX_LEN = 1000;
export const ROLE_DESCRIPTION_MAX_LENGTH = 100;
